import { useState, useLayoutEffect } from 'react'
import type { AppTheme } from '../components/map/mapStyle'

export type { AppTheme }

export function useAppTheme(): AppTheme {
  const [theme, setTheme] = useState<AppTheme>(() => {
    // DOM attribute wins (set by Layout); fall back to localStorage; default light
    const fromDOM = document.documentElement.getAttribute('data-theme') as AppTheme | null
    const fromLS = localStorage.getItem('cs-theme') as AppTheme | null
    return fromDOM || fromLS || 'light'
  })

  useLayoutEffect(() => {
    // Setup pages don't render Layout, so data-theme may never be set.
    // Ensure it's always present so CSS variables apply correctly.
    if (!document.documentElement.getAttribute('data-theme')) {
      const fallback = (localStorage.getItem('cs-theme') as AppTheme | null) || 'light'
      document.documentElement.setAttribute('data-theme', fallback)
    }
    const obs = new MutationObserver(() => {
      const t = document.documentElement.getAttribute('data-theme') as AppTheme | null
      if (t) setTheme(t)
    })
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] })
    return () => obs.disconnect()
  }, []) // intentionally empty — runs once on mount

  return theme
}
